module.exports = __webpack_public_path__ + "img/mail-template.16f03f15.svg";